// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { sparkles16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-sparkles': IconSparkles;
    }
}

/**
 * The icon component for the 'sparkles' icon
 */
export class IconSparkles extends IconSvg {
    public constructor() {
        super(sparkles16X16);
    }
}

registerIconSvg('icon-sparkles', IconSparkles);
export const iconSparklesTag = 'nimble-icon-sparkles';
